import { API_METHOD, MODULE_DOC_AI, FILESTORAGE } from '@/services/endpoints';
import apiCall from '@/lib/api';
import type {
  ModuleDocAiListResponse,
  ModuleDocAiResponse,
  CreateModuleDocAiPayload,
  ModuleDocAiQueryParams,
} from '../types';

export const getModuleDocAis = async (params?: ModuleDocAiQueryParams) => {
  const queryParams = new URLSearchParams();
  if (params?.userType) queryParams.append('userType', params.userType);
  if (params?.appType) queryParams.append('appType', params.appType);
  if (params?.search) queryParams.append('search', params.search);

  const queryString = queryParams.toString();
  const url = queryString ? `${MODULE_DOC_AI.GET_MODULE_DOC}?${queryString}` : MODULE_DOC_AI.GET_MODULE_DOC;

  return apiCall<ModuleDocAiListResponse>({
    type: API_METHOD.GET,
    url,
  });
};

export const getModuleDocAiById = async (id: string) => {
  return apiCall<ModuleDocAiResponse>({
    type: API_METHOD.GET,
    url: `${MODULE_DOC_AI.GET_MODULE_DOC}/${id}`,
  });
};

export const createModuleDocAi = async (payload: CreateModuleDocAiPayload) => {
  return apiCall<ModuleDocAiResponse>({
    type: API_METHOD.POST,
    url: MODULE_DOC_AI.POST_MODULE_DOC,
    body: payload as unknown as Record<string, unknown>,
  });
};

export const updateModuleDocAi = async (id: string, payload: CreateModuleDocAiPayload) => {
  return apiCall<ModuleDocAiResponse>({
    type: API_METHOD.PUT,
    url: `${MODULE_DOC_AI.PUT_MODULE_DOC}/${id}`,
    body: payload as unknown as Record<string, unknown>,
  });
};

export const deleteModuleDocAi = async (id: string) => {
  return apiCall<ModuleDocAiResponse>({
    type: API_METHOD.DELETE,
    url: `${MODULE_DOC_AI.DELETE_MODULE_DOC}/${id}`,
  });
};

export const uploadModuleDocAiFile = async (formData: FormData) => {
  return apiCall<{ status: boolean; data: { id: string }[] }>({
    type: API_METHOD.POST,
    url: FILESTORAGE.POST_FILE_STORAGE,
    body: formData as unknown as Record<string, unknown>,
    isFormData: true,
  });
};

export const moduleDocAiService = {
  getModuleDocAis,
  getModuleDocAiById,
  createModuleDocAi,
  updateModuleDocAi,
  deleteModuleDocAi,
  uploadModuleDocAiFile,
};
export default moduleDocAiService;
